module.exports = __webpack_public_path__ + "img/2.0a55c9d5.jpeg";